import { useNavigate } from "react-router-dom";
import config from "../common/Config";
import useAuth from "../hooks/useAuth"
import refreshToken from "./refreshToken"

const useInternalFetch = () => {
	const { auth, setAuth } = useAuth();
	const navigate			= useNavigate();

	const internalFetch = async (url, options) => {
		options = {
			...options,
			headers: { ...(options?.headers ?? {}), authorization: 'Bearer ' + auth.accessToken }
		}

		const tryAccessToken = await fetch(url, options)
		// .then(data => data.json())
		.catch(e => new Object().status = 500)

		if (tryAccessToken.status == 200) {
			return await tryAccessToken.json()
		}
		else if (tryAccessToken.status == 429) {
			navigate('/error/tooManyRequests')
			return { 
				status		: 429,
				message 	: "Muitas Conexões! Tente novamente mais tarde."
			}			
		}		
		else {
			const refresh = await refreshToken()

			if (refresh.success) {
				const data = refresh.data

				setAuth({
					userId		: data.userId,
					user		: data.user,
					accessToken	: data.accessToken
				})

				options = {
					...options,
					headers: { ...(options?.headers ?? {}), authorization: 'Bearer ' + data.accessToken }
				}

				return await fetch(url, options)
				.then(async result => {
					if (result.status === 429) {
						navigate('/error/tooManyRequests')
						return { status: 429, message: 'Muitas Conexões! Tente novamente mais tarde.' }
					}
					const results = await result.json()
					if (result.status !== 200) return { status: result.status, message: results.message }
					return results
				})
				.catch(() => ({ status: 500, message: 'Falha na autenticação! Efetuar novo login!' }))
			}
			else if (refresh.status == 429) {
				navigate('/error/tooManyRequests')
				return { status: 429, message: 'Muitas Conexões! Tente novamente mais tarde.' }
			}
			else {
				window.location.reload();
				await new Promise(r => setTimeout(r, 2000));
				return { status: 500, message: 'Falha na autenticação! Efetuar novo login!' }
			}
		}
	}

	return internalFetch
}

export default useInternalFetch